import { render } from "./Final.vue?vue&type=template&id=6f240d12&scoped=true"
import script from "./Final.vue?vue&type=script&lang=js"
export * from "./Final.vue?vue&type=script&lang=js"

import "./Final.vue?vue&type=style&index=0&id=6f240d12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f240d12"]])

export default __exports__